import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SoloCompiElement from "./SoloCompiElement";

const SoloCompiPage = ({ competition, setCompetition }) => {
  const navigate = useNavigate();
  const [participants, setParticipants] = useState([]);
  const [onlineSubmission, setOnlineSubmission] = useState([]);

  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  function formatDate(date) {
    return [
      padTo2Digits(date.getDate()),
      padTo2Digits(date.getMonth() + 1),
      date.getFullYear(),
    ].join("/");
  }

  const getCompiParticipants = async () => {
    await Axios.get(
      `https://ashish.moodi.org/competitions/get_solo_compi_reg?id=${competition.competitionId}`
    )
      .then((res) => setParticipants(res.data))
      .catch((err) => console.error(err));
  };

  const getOnlineSubmission = () => {
    Axios.post(
      "https://ashish.moodi.org/competitions/get_onlin_submission",
      {
        competition: competition.competitionId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => setOnlineSubmission(res.data))
      .catch((err) => console.error(err));
  };

  const download_csv_file = () => {
    if (competition.isOnline) {
      let csv =
        ",Name,MI Number,Phone,Email,College,City,SubmissionLink,SubmittedOn\n";
      participants.forEach((participant) => {
        let collegeName = participant.collegeName.replace(/,/g, " ");
        let cityName = participant.cityName.replace(/,/g, " ");
        let submissionLink = onlineSubmission.find(
          (element) => element.userTeamId === participant.userId
        )
          ? onlineSubmission.find(
              (element) => element.userTeamId === participant.userId
            ).submissionLink
          : "";
        let submittedOn = onlineSubmission.find(
          (element) => element.userTeamId === participant.userId
        )
          ? formatDate(
              new Date(
                onlineSubmission.find(
                  (element) => element.userTeamId === participant.userId
                ).submittedOn
              )
            )
          : "";
        csv +=
          participant.userName +
          "," +
          participant.MI_NO +
          "," +
          participant.phone +
          "," +
          participant.email +
          "," +
          collegeName +
          "," +
          cityName +
          "," +
          submissionLink +
          "," +
          submittedOn +
          "\n";
      });
      let hiddenElement = document.createElement("a");
      console.log(csv);
      hiddenElement.href = "data:text/csv;charset=utf-8" + encodeURI(csv);
      hiddenElement.target = "_blank";
      hiddenElement.download = `${competition.competitionName}.csv`;
      hiddenElement.click();
    } else {
      let csv = ",Name,MI Number,Phone,Email,College,City\n";
      participants.forEach((participant) => {
        let collegeName = participant.collegeName.replace(/,/g, " ");
        let cityName = participant.cityName.replace(/,/g, " ");
        csv +=
          participant.userName +
          "," +
          participant.MI_NO +
          "," +
          participant.phone +
          "," +
          participant.email +
          "," +
          collegeName +
          "," +
          cityName +
          "\n";
      });
      let hiddenElement = document.createElement("a");
      console.log(csv);
      hiddenElement.href = "data:text/csv;charset=utf-8" + encodeURI(csv);
      hiddenElement.target = "_blank";
      hiddenElement.download = `${competition.competitionName}.csv`;
      hiddenElement.click();
    }
  };

  useEffect(() => {
    getCompiParticipants();
    if (competition.isOnline) {
      getOnlineSubmission();
    }
    // eslint-disable-next-line
  }, [competition]);

  return (
    <div className="container-fluid overflow-auto">
      <div className="row my-3">
        <h2 className="text-center col-sm-3">{competition.competitionName}</h2>
        <p className="text-center col-sm-2">
          Total registrations: {participants.length}
        </p>
        {competition.isOnline ? (
          <p className="text-center col-sm-1">
            True: {onlineSubmission.length}
          </p>
        ) : (
          <></>
        )}
        <button
          className="btn btn-primary col-sm-2"
          onClick={download_csv_file}
        >
          Download CSV
        </button>
        <button
          className="btn btn-primary col-sm-2"
          onClick={() =>
            navigate(
              `/admin/competitions/slotting/${competition.competitionId}`
            )
          }
        >
          Do Slotting
        </button>
        <button
          className="btn btn-primary col-sm-2"
          onClick={() =>
            navigate(`/admin/mul/compi_score/${competition.competitionId}`)
          }
        >
          View Score Sheet
        </button>
      </div>
      <table className="container-fluid overflow-auto">
        <thead>
          <tr className="overflow-auto">
            {competition.isSlottingDone ? (
              <th className="">Slot Number</th>
            ) : (
              <></>
            )}
            <th>Name</th>
            <th>MI Number</th>
            <th>Phone</th>
            <th>Email</th>
            {competition.isOnline ? (
              <>
                <th>inSemis</th>
                <th>inFinals</th>
              </>
            ) : (
              <></>
            )}
            <th>College</th>
            <th>City</th>
            {competition.isOnline ? (
              <>
                <th>Submission Link</th>
                <th>Submitted On</th>
              </>
            ) : (
              <></>
            )}
            <hr />
            <hr />
          </tr>
        </thead>
        <tbody>
          {participants.map((participant) => {
            console.log(participant);
            return (
              <SoloCompiElement
                participant={participant}
                competition={competition}
                onlineSubmission={onlineSubmission}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SoloCompiPage;
